'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FilterDebug = function FilterDebug(props) {
  return _react2.default.createElement('div', {
    className: 'filter__debug'
  }, _react2.default.createElement('table', {
    className: 'filter__table'
  }, _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', null, 'All Items: ', props.filter.props.items.length))), _react2.default.createElement('tbody', null, props.filter.props.items.map(function (item) {
    return _react2.default.createElement('tr', null, _react2.default.createElement('td', null, item.name));
  }))), _react2.default.createElement('table', {
    className: 'filter__table'
  }, _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', null, 'Filtered Items: ', props.filteredItems.length))), _react2.default.createElement('tbody', null, props.filteredItems.map(function (item) {
    return _react2.default.createElement('tr', null, _react2.default.createElement('td', null, item.name));
  }))), _react2.default.createElement('table', {
    className: 'filter__table'
  }, _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', null, 'Active Filters: ', props.filter.state.filters.length))), _react2.default.createElement('tbody', null, props.filter.state.filters.map(function (filter) {
    return _react2.default.createElement('tr', null, _react2.default.createElement('td', null, filter.attribute, ': ', filter.value));
  }))));
};
FilterDebug.propTypes = {
  filter: _propTypes2.default.node.isRequired,
  filteredItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired
};
exports.default = FilterDebug;